import { Component, OnInit, ViewChild } from '@angular/core';
import { ExpandedDetails, IndustryReportsService, VettingInsightsFilters, VettingInsightsResults } from 'src/app/services/industry-reports.service';
import { IuiMessagesComponent } from 'src/app/shared/messages/messages.component';
import { MultiSelect } from 'primeng/multiselect';
import { TableColumn } from 'src/app/models/table-columns';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { NgForm } from '@angular/forms';
import { Table } from 'primeng/table';
import { ConfigService } from '../../../../services';
import { ScrEnvironment } from '../../../../../environments/environment';

@Component({
  selector: 'app-vetting-insights',
  templateUrl: './vetting-insights.component.html',
  styleUrls: ['./vetting-insights.component.scss']
})
export class VettingInsightsComponent extends ScrBaseComponent implements OnInit {
  @ViewChild('message', { static: false }) message!: IuiMessagesComponent;
  @ViewChild('findingsDropdown', { static: false }) findingsDropdown!: MultiSelect;
  @ViewChild('VettingInsights', { static: false }) table!: Table;

  findingsOptions: { name: string, value: string }[] = [];
  vetTypeOptions: { name: string, value: string }[] = [
    { name: 'High-Risk Message Sender', value: 'High-Risk Message Sender' },
    { name: 'Leaseholder', value: 'Leaseholder' }
  ];
  radioBtnSelection = 'companyName';
  today = new Date();
  filterChoices: VettingInsightsFilters = { vetTypeChoices: ['High-Risk Message Sender', 'Leaseholder'] } as VettingInsightsFilters;
  results: VettingInsightsResults[] = [];
  tableColumn: TableColumn[] = [
    { field: 'companyName', localizationKey: 'organizationName' },
    { field: 'vetType' },
    { field: 'accountId' },
    { field: 'customerSince' },
    { field: 'leasedShortCodesCount', localizationKey: 'leasedCodes' },
    { field: 'vettingInsightsCount' }
  ];
  innerTableColumn: TableColumn[] = [
    { field: 'notificationDate' },
    { field: 'finding' },
    { field: 'determination' },
  ];
  showResults = false;
  brandsEnabled = false;
  resultsDetails = new Map<number, object>();

  constructor(
    private industryReportsService: IndustryReportsService,
    private configService: ConfigService,
    private environment: ScrEnvironment,
  ) { super(); }

  ngOnInit(): void {
    this.localizeTableColumns(this.tableColumn);
    this.localizeTableColumns(this.innerTableColumn);

    this.subscriptions.push(this.configService.getConfig().subscribe(cfg => {
      this.brandsEnabled = cfg.brandsEnabled;
      // only show in dev for now and if brands enabled is true.
      if (cfg.brandsEnabled && this.environment.stage === 'scr-dev') {
        this.vetTypeOptions.unshift(    { name: 'Brand', value: 'Brand' } );
        if (this.filterChoices.findingsChoices) {
          this.filterChoices.findingsChoices.unshift('Brand');
        }
      }
    }));

    this.fetchFindings();
  }

  fetchFindings() {
    this.findingsOptions = [];
    this.industryReportsService.getBrandIdentificationFilters().subscribe(res => {
      res.data.findings.forEach(finding => {
        this.findingsOptions.push({ name: finding, value: finding });
      });
      this.filterChoices.findingsChoices = res.data.findings;
    });
  }

  submitQuery(form: NgForm) {
    if (this.filterChoices.startDate && this.filterChoices.endDate && this.filterChoices.startDate > this.filterChoices.endDate) {
      this.displayLocalizedError('scr.enddatestartdate.invalid', undefined, 'message');
      return;
    }
    if(this.filterChoices.startDate && this.filterChoices.endDate) {
      // PrimeNG adds UTC offset. 
      this.filterChoices.endDate.setHours(24);
    }
    this.clearErrors();
    this.resetQuery();
    if (form.valid && this.approvedFilters(this.filterChoices)) {
      this.industryReportsService.getVettingInsightSummary(this.filterChoices).subscribe(res => {
        this.results = res.data.content;
        this.results.forEach((result, i) => result.uniqueId = i++);
        this.showResults = true;
      });
    } else if (!this.approvedFilters(this.filterChoices)) {
      this.displayLocalizedError('scr.vetting.invalidFilters');
    }
  }

  approvedFilters(filterChoices: VettingInsightsFilters) {
    if (filterChoices.companyName || filterChoices.shortCode || (filterChoices.findingsChoices && filterChoices.findingsChoices.length > 0))
      return true;
    else
      return false;
  }

  resetQuery() {
    this.resultsDetails = new Map();
    this.results = [] as VettingInsightsResults[];
    this.showResults = false;
  }

  hardResetQuery() {
    this.resetQuery();
    this.filterChoices = { vetTypeChoices: [ 'High-Risk Message Sender', 'Leaseholder'] } as VettingInsightsFilters;
    if (this.brandsEnabled && this.environment.stage === 'scr-dev') {
      this.filterChoices.vetTypeChoices.unshift('Brand');
    }
    this.radioBtnSelection = 'companyName';
    this.fetchFindings();
  }

  getAccountInfo(accountId: string, companyName: string, vetType: string,uniqueId: number) {
    if (!this.resultsDetails.get(uniqueId))
      this.loadAccountInfo(accountId, companyName, vetType, uniqueId);
  }

  loadAccountInfo(accountId: string, companyName: string, vetType: string, uniqueId: number) {
    this.industryReportsService.getVettingInsightAccount(accountId, companyName, vetType).subscribe(res => {
      const index = this.results.map(result => result.uniqueId).indexOf(uniqueId);
      this.results[index].expandedDetails = res.data;
      this.resultsDetails.set(uniqueId, res.data);
      if (this.results[index].expandedDetails) {
        this.results[index].expandedDetails.vetInsights.forEach(obj => {
          if (!obj.determination) {
            obj.determination = '- -';
          }
        });
      }
      return false;
    });
  }



  getExpandedAlias(expandedResults: ExpandedDetails) {
    if(expandedResults.legalName && !expandedResults.companyName) {
      return expandedResults.legalName;
    } else if (!expandedResults.legalName && expandedResults.companyName) {
      return expandedResults.companyName;
    } else if (expandedResults.legalName === expandedResults.companyName) {
      return expandedResults.legalName;
    } else {
      return `${expandedResults.legalName}, ${expandedResults.companyName}`;
    }
  }

  test() {
    console.log(this.resultsDetails);
    console.log(this.results);
  }
}


